import {
  getPeriodDates,
  getYMDFormatDTString,
  getYMDHMSFormatDTString,
} from "utils/dateUtil";
import axios from "./axios";
import { API_ERROR_CODE } from "./utils/dataCenter";

const prefix = "/v2/orders";

// export function getOrderRateDataByAllIngredients(
//   COMPANY_ID: string,
//   startDate: Date,
//   endDate: Date
// ) {
//   return new Promise(async (resolve, reject) => {
//     try {
//       startDate.setHours(0, 0, 0, 0);
//       endDate.setHours(23, 59, 59, 999);
//       const searchParams = new URLSearchParams({
//         COMPANY_ID,
//         startDate: getYMDFormatDTString(startDate),
//         endDate: getYMDFormatDTString(endDate),
//       });
//       const response = await axios.get(
//         `${prefix}/getOrderRateDataByAllIngredients?${searchParams.toString()}`
//       );
//       resolve(response);
//     } catch (e) {
//       console.log(`${prefix} getOrderRateDataByAllIngredients error: `, e);
//       reject(e);
//     }
//   });
// }

// export function getSalesAndOrdersAndNangmanAmountByPlant( // 발주 분석
//   COMPANY_ID: string,
//   SHOP_ID: string,
//   startDate: Date,
//   endDate: Date
// ) {
//   return new Promise(async (resolve, reject) => {
//     try {
//       startDate.setHours(0, 0, 0, 0);
//       endDate.setHours(23, 59, 59, 999);
//       const searchParams = new URLSearchParams({
//         COMPANY_ID,
//         SHOP_ID,
//         startDate: getYMDFormatDTString(startDate),
//         endDate: getYMDFormatDTString(endDate),
//       });
//       const response = await axios.get(
//         `${prefix}/getCompanyOrdersBySalesByDate?${searchParams.toString()}`
//       );
//       resolve(response);
//     } catch (e) {
//       console.log(
//         `${prefix} getSalesAndOrdersAndNangmanAmountByPlant error: `,
//         e
//       );
//       reject(e);
//     }
//   });
// }

export function modifyPurchaseOrder(SHOP_ID: string, items: any) {
  console.log("items", items);

  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(`${prefix}/modifyPurchaseOrder`, {
        SHOP_ID,
        items,
      });
      console.log(`${prefix}modifyPurchaseOrder response: `, response);
      resolve(response);
    } catch (e) {
      console.log(`${prefix}modifyPurchaseOrder error: `, e);
      reject(e);
    }
  });
}

export function getShopOrdersBySalesByDate( // 일자별 발주 금액
  COMPANY_ID: string,
  SHOP_ID: string,
  startDate: Date,
  endDate: Date
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
      const searchParams = new URLSearchParams({
        COMPANY_ID,
        SHOP_ID,
        startDate: getYMDFormatDTString(startDate),
        endDate: getYMDFormatDTString(endDate),
        searchDates: JSON.stringify(
          getPeriodDates(
            getYMDFormatDTString(startDate),
            getYMDFormatDTString(endDate)
          )
        ),
      });
      const response = await axios.get(
        `${prefix}/getShopOrdersBySalesByDate?${searchParams.toString()}`
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getShopOrdersBySalesByDate error: `, e);
      reject(e);
    }
  });
}

export function getShopOrdesByItemsByDate( // 재료별
  COMPANY_ID: string,
  SHOP_ID: string,
  startDate: Date,
  endDate: Date
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
      const searchParams = new URLSearchParams({
        COMPANY_ID,
        SHOP_ID,
        startDate: getYMDFormatDTString(startDate),
        endDate: getYMDFormatDTString(endDate),
      });
      const response = await axios.get(
        `${prefix}/getShopOrdesByItemsByDate?${searchParams.toString()}`
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getShopOrdesByItemsByDate error: `, e);
      reject(e);
    }
  });
}

export function getCompanyOrdersBySalesByDate(
  COMPANY_ID: string,
  startDate: Date,
  endDate: Date
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
      const searchParams = new URLSearchParams({
        COMPANY_ID,
        startDate: getYMDFormatDTString(startDate),
        endDate: getYMDFormatDTString(endDate),
      });
      const response = await axios.get(
        `${prefix}/getCompanyOrdersBySalesByDate?${searchParams.toString()}`
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getCompanyOrdersBySalesByDate error: `, e);
      reject(e);
    }
  });
}

export function getCompanyOrdesByItemsByDate(
  COMPANY_ID: string,
  startDate: Date,
  endDate: Date
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
      const searchParams = new URLSearchParams({
        COMPANY_ID,
        startDate: getYMDFormatDTString(startDate),
        endDate: getYMDFormatDTString(endDate),
      });
      const response = await axios.get(
        `${prefix}/getCompanyOrdesByItemsByDate?${searchParams.toString()}`
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getCompanyOrdesByItemsByDate error: `, e);
      reject(e);
    }
  });
}

export function getReportOrders(
  COMPANY_ID: string,
  SHOP_IDS: string[],
  startDate: Date,
  endDate: Date
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
      const response = await axios.post(`${prefix}/getReportOrdersByDate`, {
        COMPANY_ID,
        SHOP_IDS,
        startDate: getYMDFormatDTString(startDate),
        endDate: getYMDFormatDTString(endDate),
      });
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getReportOrders error: `, e);
      reject(e);
    }
  });
}
